'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.run(function (defaultChartOptions, highchartFullscreenOpener) {
  defaultChartOptions.exporting.buttons.contextButton.menuItems.push({
    textKey: 'AfficherEnPleinEcran',
    onclick: function onclick() {
      highchartFullscreenOpener.openFullscreenPopin(this);
    }
  });
});
ngModule.factory("highchartFullscreenOpener", function ($modal) {
  return {
    openFullscreenPopin: function openFullscreenPopin(chart) {
      $modal.open({
        controller: "highchartFullscreenPopinController",
        template: require("./highchartFullscreenPopin.html"),
        vars: {
          originalChart: chart
        },
        options: {
          fullWidth: true
          //width : 1220
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/highcharts/full-screen/highchartFullscreenOpener.js
// module id = 2959
// module chunks = 13